// extracted by mini-css-extract-plugin
export var actionButton = "_cz-0";
export var attachmentLine = "_cz-1";
export var fileInput = "_cz-2";
export var fileUploadWrapper = "_cz-4";
export var footer = "_cz-3";
export var modalContent = "_cz-5";
export var paperclip = "_cz-6";
export var quillEditor = "_cz-7";